module.exports = __webpack_public_path__ + "static/media/visa.7654bd96.svg";